import * as React from "react";

function Arrow(props) {
  return (
    <svg
      viewBox="0 0 17 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`w-4 h-4 ml-2 flex-shrink-0 group-hover:animate-glide transform-gpu ${props?.className || ""}`}
      aria-label="Arrow"
    >
      <path
        d="M1 7h15M10 13l6-6-6-6"
        stroke="currentColor"
        strokeWidth={props?.strokeWidth || 2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Arrow;